// Central brand config — single source of truth on the frontend.
export const BRAND = {
  name: "Maziara",
  domain: "maziara.com",
  url: "https://maziara.com",
  tagline: "Conversations without judgement",
  supportEmail: "support@maziara.com",
  positioning:
    "A private adult conversation platform where you can meet a real stranger or explore a fictional AI personality—without followers, public profiles or social validation.",
};

export const AI_DISCLAIMER =
  "Maziara uses fictional AI personas. They are not real people, therapists or emergency-support professionals.";

export default BRAND;
